// extracted by mini-css-extract-plugin
export default {"modal":"modal--B0vG6","content":"content--n22qP","name":"name--aFFpl","field":"field--XAl7x","blink":"blink--PnHLo"};